import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from "vue-click-outside";
import NotificationPopover from "@Shared/components/general/notification-popover";
import { mapMultiRowFields } from "@joandvgv/vuex-map-fields";
import { mapState, mapActions, mapGetters } from "vuex";
import { UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import * as FieldComponents from "@Shared/components/sections/index";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import CreditApplicantsLoader from "./loaders/credit-applicants-loader";
import FilogixDetailsModal from "./modals/filogix-details-modal";
import Err from "../../../../../../../../routes/error";
import { requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import { isEmpty } from "lodash";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreditApplicants",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    SimpleButton,
    Loader: CreditApplicantsLoader,
    FilogixDetailsModal,
    NotificationPopover,
    IncidentMessage,
    DateSection,
    Field
  }),
  directives: {
    ClickOutside
  },
  mixins: [validationMixin],
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    missingFilogixDetailsOrAccess: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      creditSubjects: {
        $each: {
          firstName: {
            required: requiredIf(subject => subject.single)
          },
          authorizationDate: {
            required: requiredIf(subject => subject.single)
          },
          authorizationMethod: {
            required: requiredIf(subject => subject.single)
          },
          dateOfBirth: {
            required: requiredIf(subject => subject.single)
          }
        }
      }
    };
  },
  data() {
    return {
      creditPullDisabled: false,
      showPopover: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMultiRowFields("ApplicationStore", ["creditSubjects"])), mapState("ApplicationStore", ["requestingCreditBureau"])), mapState("SettingsStore", ["filogixDetails"])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    disablePull() {
      const cbOrAml = this.creditSubjects.some(creditSubject => creditSubject.bureau && !isEmpty(creditSubject.authorizationDate) && !isEmpty(creditSubject.authorizationMethod) || creditSubject.AML || creditSubject.PEP);
      if (this.creditPullDisabled || !cbOrAml) {
        return true;
      }
      return this.missingFilogixDetailsOrAccess || this.$v.$invalid;
    },
    invalidFilogixDetails() {
      const keysToCheck = ["expertLoginId", "expertProfileNumber", "subscriberNumber", "subscriberPassword", "subscriberSecurityCode", "userId"];
      if (isEmpty(this.filogixDetails)) return true;
      return keysToCheck.some(key => !this.filogixDetails[key]);
    },
    columnHeaders() {
      return [{
        label: `${this.$t("account.name")}*`,
        size: "col-2"
      }, {
        label: `${this.$t("account.birthDate")}*`,
        size: "col-2"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.authorizationObtained")}${this.creditSubjects.some(subject => subject.bureau) ? "*" : ""}`,
        size: "col"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.authorizationMethod")}${this.creditSubjects.some(subject => subject.bureau) ? "*" : ""}`,
        size: "col"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.bureau")}`,
        size: "col"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.copyLiabilities")}`,
        size: "col"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.amlAssist")}`,
        size: "col"
      }, {
        label: `${this.$t("direct-to-lender.creditBureau.pepOrSanctions")}`,
        size: "col"
      }];
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_FILOGIX_DETAILS])), {}, {
    handleRequest() {
      if (this.invalidFilogixDetails) {
        return showBModal("filogix-details-modal", this.filogixDetails, this);
      }
      if (this.creditSubjects.some(subject => subject.AML)) {
        this.$emit("requestAML");
      }
      if (this.creditSubjects.some(subject => subject.PEP)) {
        this.$emit("requestPEP");
      }
      if (this.creditSubjects.some(subject => subject.bureau)) {
        this.$emit("requestCB");
      }
    },
    handlePrintConsent() {
      this.$emit("print");
    },
    handleBureauChange(index) {
      if (this.creditSubjects[index].bureau) {
        this.creditSubjects.forEach((_, i) => {
          this.$set(this.creditSubjects[i], "AML", false);
          this.$set(this.creditSubjects[i], "PEP", false);
        });
      } else {
        this.$set(this.creditSubjects[index], "copyLiabilities", false);
      }
    },
    handleAMLChange(index) {
      if (this.creditSubjects[index].AML) {
        this.creditSubjects.forEach((_, i) => {
          this.$set(this.creditSubjects[i], "bureau", false);
          this.$set(this.creditSubjects[i], "copyLiabilities", false);
          this.$set(this.creditSubjects[i], "PEP", false);
        });
        this.$set(this.creditSubjects[index], "authorizationDate", "");
        this.$set(this.creditSubjects[index], "authorizationMethod", "");
      }
    },
    handlePEPOrSanctions(index) {
      if (this.creditSubjects[index].PEP) {
        this.creditSubjects.forEach((_, i) => {
          this.$set(this.creditSubjects[i], "bureau", false);
          this.$set(this.creditSubjects[i], "copyLiabilities", false);
          this.$set(this.creditSubjects[i], "AML", false);
        });
        this.$set(this.creditSubjects[index], "authorizationDate", "");
        this.$set(this.creditSubjects[index], "authorizationMethod", "");
      }
    },
    async handleFilogixDetailsSubmit(filogixDetails) {
      try {
        await this.UPDATE_FILOGIX_DETAILS(filogixDetails);
        this.$refs.filogixDetailsModal.hide();
        this.$emit("request");
      } catch (e) {
        this.$refs.filogixDetailsModal.hide("failed");
        Err.handle(e, {}, "errorWhileUpdatingFilogixDetails");
      } finally {
        this.filogixDetails = filogixDetails;
      }
    },
    fullSubjectName(index) {
      const currentSubject = this.creditSubjects[index];
      if (!currentSubject.firstName && !currentSubject.lastName) {
        return `${this.$options.filters.formatNumeral(index + 1, "0o")} ${this.$t("application-form.applicant").toLowerCase()}`;
      }
      return [currentSubject.firstName || "", currentSubject.lastName || ""].join(" ");
    },
    handleIncidentUpdate(hasIncident) {
      this.creditPullDisabled = hasIncident;
    }
  })
});